var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4",attrs:{"id":"list-boiler-equipment-component"}},[_c('EmptyPageComponent',{attrs:{"link_img":'/images/error/in_progress.png',"main_text":_vm.$t('global.soon_available'),"secondary_text":_vm.$t('global.module_under_construction'),"show_secondary_text":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }